import Colors from '../../theming/Colors';
import KitText from '../KitText';
import React from 'react';
import Spacing from '../../theming/Spacing';
import { View } from 'react-native';

export interface KitSectionProps {
  title?: string;
  children?: React.ReactChild;
}

const KitSection = ({ title, children }: KitSectionProps): JSX.Element => {
  return (
    <View>
      {title && (
        <KitText
          bold
          color={Colors.N900}
          fontSize={20}
          style={{ marginLeft: Spacing.l, marginBottom: Spacing.s }}
        >
          {title}
        </KitText>
      )}
      {children}
    </View>
  );
};

export default KitSection;
